<template>
  <center>
    <card class="card-user" style="width: 50%">
      <div slot="image">
        <img src="@/assets/img/background-profile.png" style="height:180px;" alt="..." />
      </div>
      <div>

        <form @submit.prevent="handleSubmit">
          <div v-if="error" class="alert alert-warning" role="alert">
            {{ error }}
          </div>
          <div class="row">
            <div class="col-md-12">
              <fg-input
                type="password" 
                label="Contraseña" 
                placeholder="Contraseña" 
                v-model="user.password"
                  pattern="(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ].*"
                  title="Debe tener al menos una mayúscula, una minúscula y un dígito" :class="{
                    'is-invalid': submitted && $v.user.password.$error
                  }"
                  style="text-align: left"
              >
              </fg-input>
              <div v-if="submitted && $v.user.password.$error" class="invalid-feedback">
                <span v-if="!$v.user.password.required">
                  Requerido
                </span>
                <span v-if="!$v.user.password.minLength">
                  <li>8 caracteres necesarios</li>
                </span>
                <span v-if="!$v.user.password.valid1">
                  <li>Al menos una mayúscula</li>
                </span>
                <span v-if="!$v.user.password.valid2">
                  <li>Al menos una minúscula</li>
                </span>
                <span v-if="!$v.user.password.valid3">
                  <li>Al menos un número</li>
                </span>
                <span v-if="!$v.user.password.valid4">
                  <li>Al menos un caractér especial</li>
                </span>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="row">
            <div class="col-md-12">
              <fg-input
                type="password"
                label="Confirmar contraseña" 
                placeholder="Contraseña" 
                v-model="user.password2"
                  pattern="(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ].*"
                  title="Debe tener al menos una mayúscula, una minúscula y un dígito" :class="{
                    'is-invalid': submitted && $v.user.password2.$error
                  }"
                  style="text-align: left;"
              >
              </fg-input>
              <div v-if="submitted && $v.user.password2.$error" class="invalid-feedback">
                <span v-if="!$v.user.password2.required">
                  Requerido
                </span>
                <span v-if="!$v.user.password2.minLength">
                  <li>8 caracteres necesarios</li>
                </span>
                <span v-if="!$v.user.password2.valid1">
                  <li>Al menos una mayúscula</li>
                </span>
                <span v-if="!$v.user.password2.valid2">
                  <li>Al menos una minúscula</li>
                </span>
                <span v-if="!$v.user.password2.valid3">
                  <li>Al menos un número</li>
                </span>
                <span v-if="!$v.user.password2.valid4">
                  <li>Al menos un caractér especial</li>
                </span>
              </div>
            </div>
          </div>

          <div><br />
            <p-button type="info" @click.native.prevent="handleSubmit" style="margin-right: 10px;">
              Enviar
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>

      </div>
    </card>
  </center>
</template>
<script>
import { required, minLength } from "vuelidate/lib/validators";
import usersService from '../../services/usersService';
import "vue-select/dist/vue-select.css";
import auth from '../../token';
import state from "../../store/state"
import store from "../../store";
import swal from 'sweetalert';
export default {
  data() {
    return {
      error: '',
      user: {
        password: '',
        password2: ''
      },
      submitted: false
    };
  },
  validations: {
    user: {
      password: {
        required,
        minLength: minLength(8),
        valid1: function (value) {
          const containsUppercase = /[A-Z]/.test(value);
          return containsUppercase;
        },
        valid2: function (value) {
          const containsLowercase = /[a-z]/.test(value);
          return containsLowercase;
        },
        valid3: function (value) {
          const containsNumber = /[0-9]/.test(value);
          return containsNumber;
        },
        valid4: function (value) {
          const containsSpecial = /[#?!@$%^&*-_]/.test(value);
          return containsSpecial;
        },
      },
      password2: {
        required,
        minLength: minLength(8),
        valid1: function (value) {
          const containsUppercase = /[A-Z]/.test(value);
          return containsUppercase;
        },
        valid2: function (value) {
          const containsLowercase = /[a-z]/.test(value);
          return containsLowercase;
        },
        valid3: function (value) {
          const containsNumber = /[0-9]/.test(value);
          return containsNumber;
        },
        valid4: function (value) {
          const containsSpecial = /[#?!@$%^&*-_]/.test(value);
          return containsSpecial;
        },
      }
    }
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if(this.user.password !== this.user.password2) {
        this.error = 'Las contraseñas no coinciden';
        return;
      }

      this.createUser();
    },
    async createUser() {
      const form = {
        userId: auth.getUserID(),
        newPassword: this.user.password
      };

      const resp = await usersService.restoreUserPassword(form);
      if(!resp.error) {
        swal({
          title: 'Exitoso', 
          text: 'Se actualizo la contraseña, hasta pronto', 
          icon: 'success', 
          timer: 3000, 
          buttons: false
        })
        setTimeout(() => {
          auth.logout();
        }, 3000);
      }
    }
  },
};
</script>
<style>
.card .card-image {
  height: 190px !important;
}
</style>
